import { jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '../../../../../infra/dls/components/button/button';
export var TwoFaSwitchMethod = function (_a) {
    var method = _a.method, disabled = _a.disabled, onSwitchMethod = _a.onSwitchMethod;
    return (_jsxs(Button.Secondary, { fullWidth: true, disabled: disabled, type: "button", onClick: onSwitchMethod, children: ["Verify with ", method === 'phone' ? 'email' : 'phone'] }));
};
